import {
  caseDetailDiff,
  type CaseDetailChangedEntry,
  type CaseDetailDiffContext
} from './case-accelerator';

export type CaseDetailDiffResult = {
  differs: boolean;
  changes: CaseDetailChangedEntry[];
};

export type CaseDetailDiffRunner = (
  phase1: CMxAPI.Case,
  phase2: CMxAPI.Case,
  context?: CaseDetailDiffContext,
  signal?: AbortSignal
) => CaseDetailDiffResult | Promise<CaseDetailDiffResult>;

function rejectIfAborted(signal?: AbortSignal): void {
  if (!signal?.aborted) {
    return;
  }
  throw signal.reason instanceof DOMException
    ? signal.reason
    : new DOMException('The operation was aborted.', 'AbortError');
}

const defaultDiffRunner: CaseDetailDiffRunner = (phase1, phase2, context, signal) => {
  rejectIfAborted(signal);
  return caseDetailDiff(phase1, phase2, context);
};

let diffRunner: CaseDetailDiffRunner = defaultDiffRunner;

export function setCaseDetailDiffRunner(runner: CaseDetailDiffRunner): void {
  diffRunner = runner;
}

export function getCaseDetailDiffRunner(): CaseDetailDiffRunner {
  return diffRunner;
}

/** Restores the synchronous default runner (unit tests). */
export function resetCaseDetailDiffRunnerForTests(): void {
  diffRunner = defaultDiffRunner;
}

export async function runCaseDetailDiff(
  phase1: CMxAPI.Case,
  phase2: CMxAPI.Case,
  context?: CaseDetailDiffContext,
  signal?: AbortSignal
): Promise<CaseDetailDiffResult> {
  return getCaseDetailDiffRunner()(phase1, phase2, context, signal);
}
